module.exports = __webpack_public_path__ + "static/media/Capture.4657d4ce.PNG";